import TranslateTextLogic from "../../components/RecordingFeatures/TranslateText";
import "../../css/app/aiResults.css";

const TranslateTextPage = () => {

    return (
        <div className="vr-air-page">
            <TranslateTextLogic />
        </div>
    );
};

export default TranslateTextPage;
